(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.querySelectorAll('.media-gallery__grid-thumbnail').forEach((btn) => {
        btn.addEventListener('click', this.onClick);
      });
    }

    disconnectedCallback() {
      this.querySelectorAll('.media-gallery__grid-thumbnail').forEach((btn) => {
        btn.removeEventListener('click', this.onClick);
      });
    }

    onClick(event) {
      const targetId = event.currentTarget.getAttribute('data-target-id');
      if (!targetId) return;
      const target = this.parentElement.querySelector(`#${CSS.escape(targetId)}`);
      if (!target) return;

      const rect = target.getBoundingClientRect();
      const absoluteTop = window.scrollY + rect.top;
      window.scrollTo({ top: Math.max(absoluteTop, 0), behavior: 'smooth' });
    }
  }

  customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class SubscriptionUpsell extends HTMLElement {
  connectedCallback() {
    this.buyOnceRadio = this.querySelector('input[value="one_time"]');
    this.subscribeRadio = this.querySelector('input[value="subscribe"]');
    this.atcGroup = this.closest('.buy-buttons-block')?.querySelector('[data-atc-group]');
    this.buildCta = this.querySelector('[data-build-subscription]');
    this.subscriptionOption = this.querySelector('[data-subscription-option]');
    this.onetimeOption = this.querySelector('[data-onetime-option]');
    this.onChange = this.onChange.bind(this);
    [this.buyOnceRadio, this.subscribeRadio].forEach((el) => el && el.addEventListener('change', this.onChange));
    this.onChange();
  }

  disconnectedCallback() {
    [this.buyOnceRadio, this.subscribeRadio].forEach((el) => el && el.removeEventListener('change', this.onChange));
  }

  onChange() {
    const isSubscribe = this.subscribeRadio?.checked;
    if (!this.atcGroup || !this.buildCta) return;
    
    // Handle visibility
    if (isSubscribe) {
      this.atcGroup.classList.add('hidden');
      this.buildCta.classList.remove('hidden');
    } else {
      this.atcGroup.classList.remove('hidden');
      this.buildCta.classList.add('hidden');
    }
    
    // Handle border colors
    if (this.subscriptionOption && this.onetimeOption) {
      if (isSubscribe) {
        // Subscription selected
        this.subscriptionOption.classList.remove('border-grey');
        this.subscriptionOption.classList.add('border-california-cabernet');
        this.onetimeOption.classList.remove('border-california-cabernet');
        this.onetimeOption.classList.add('border-grey');
      } else {
        // One-time selected
        this.subscriptionOption.classList.remove('border-california-cabernet');
        this.subscriptionOption.classList.add('border-grey');
        this.onetimeOption.classList.remove('border-grey');
        this.onetimeOption.classList.add('border-california-cabernet');
      }
    }
  }
}

customElements.define('subscription-upsell', SubscriptionUpsell);
  } catch(e) { console.error(e); }
})();

})();
